import cn from 'classnames';
import { Dialog } from 'primereact/dialog';
import { Trans, useTranslation } from 'react-i18next';

import { ApproveCampaignProgressBar } from '@features/campaigns/details/components/ApproveCampaignProgressBar/ApproveCampaignProgressBar.tsx';
import { DefaultActionsFooter } from '@shared/components/Modal/Footers/DefaultActionsFooter/DefaultActionsFooter';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './ApproveCampaignModal.module.scss';

interface ApproveCampaignModalProps {
  isVisible: boolean;
  toggleModalVisibility: () => void;
  approveCallback: () => void;
  campaignName: string;
  submitCallbackActionIsLoading: boolean;
  submitCallbackActionIsCompleted: boolean;
}

export function ApproveCampaignModal({
  isVisible,
  toggleModalVisibility,
  approveCallback,
  campaignName,
  submitCallbackActionIsLoading,
  submitCallbackActionIsCompleted,
}: ApproveCampaignModalProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  const shouldDisplayUIElement = !submitCallbackActionIsLoading;

  return (
    <Dialog
      visible={isVisible}
      onHide={toggleModalVisibility}
      closable={shouldDisplayUIElement}
      draggable={false}
      resizable={false}
      header={shouldDisplayUIElement && t('page.campaignDetails.campaignDetailsTab.modals.headers.approveCampaign')}
      className={cn(styles.minWidth, styles.maxWidth)}
      ariaCloseIconLabel={t('dialog.closeButton', { ns: i18nNameSpace.COMMON })}
      footer={
        shouldDisplayUIElement ? (
          <DefaultActionsFooter
            submitLabel={t('page.campaignDetails.campaignDetailsTab.modals.yesApprove')}
            cancelLabel={t('page.campaignDetails.campaignDetailsTab.modals.cancel')}
            cancelCallback={toggleModalVisibility}
            submitCallback={approveCallback}
            submitCallbackActionIsLoading={submitCallbackActionIsLoading}
          />
        ) : (
          <div />
        )
      }
    >
      {submitCallbackActionIsLoading ? (
        <ApproveCampaignProgressBar completed={submitCallbackActionIsCompleted} />
      ) : (
        <Trans
          t={t}
          i18nKey={'page.campaignDetails.campaignDetailsTab.modals.content.approveConfirmationQuestion'}
          values={{ campaignName }}
        >
          Are you sure you want to approve <strong className={styles.boldCampaignName}>{campaignName}</strong>?
        </Trans>
      )}
    </Dialog>
  );
}
